import React, { Component } from 'react';
import './ApplePayButton.scss';
import paymentService from "../../../services/paymentService";

class ApplePayButton extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    onApplePayButtonClicked() {
        paymentService.applePayPayment();
    }

    render() {
        return (
            <div className={'apple-pay-button-container'}>
                <button onClick={this.onApplePayButtonClicked} lang={this.props.buttonLocale} className={`apple-pay-button-with-text apple-pay-button-${this.props.buttonColor}-with-text`}></button>
            </div>
        );
    }
}

export default ApplePayButton;



// WEBPACK FOOTER //
// ./src/components/PayButtons/ApplePayButton/ApplePayButton.js